<template>
  <b-modal
    body-class="px-4 pb-4 pt-2"
    centered
    v-model="show"
    header-class="header-class-modal-withdraw-request"
    hide-footer
    size="lg"
  >
    <upload-invoices :transactions_ready_withdraw="transactions_ready_withdraw"  @update_transaction="$emit('update_transaction')"></upload-invoices>
  </b-modal>
</template>
    
<script>
import { 
  BModal,
} from "bootstrap-vue";

export default {
  name: "ModalWithdrawMoney",
  components: {
    BModal,
    uploadInvoices: () => import('@/views/forms/uploadReceives.vue')
  },
  data() {
    return {
      show: this.show_modal,
    };
  },
  props: {
    show_modal: {
      type: Boolean,
      required: true,
    },
    transactions_ready_withdraw: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
};
</script>
<style lang="scss">
.header-class-modal-withdraw-request {
  background-color: white !important;
}
</style>